import React from 'react'
import PropTypes from 'prop-types'

import { ContextComposer } from '../../../components/HOCs/ContextComposer'
import { ApplicationProvider } from '../../../contexts/ApplicationContext'
import { ActionablesProvider } from '../../../contexts/ActionablesContext'

export const OnboardingRiskProvider = ({ userDetails, tenant, colors, children }) => {
  const contextValue = {
    trackingDetails: constructTrackingDetails(userDetails, tenant),
    user: constructUserDetails(userDetails),
    theme: {...colors}
  }
  const providers = [
    <ApplicationProvider value={contextValue} />,
    <ActionablesProvider
      location='onboarding'
      tenant={tenant}
      userDetails={userDetails}
    />
  ]

  return (
    <ContextComposer providers={providers}>
      {children}
    </ContextComposer>
  )
}

const constructTrackingDetails = (userDetails, tenantSlug) => (
  {
    client_id: userDetails.client_id,
    client_email: userDetails.client_email,
    current_tenant: tenantSlug
  }
)

const constructUserDetails = (userDetails) => (
  {
    ...userDetails
  }
)

OnboardingRiskProvider.propTypes = {
  userDetails: PropTypes.object.isRequired,
  tenant: PropTypes.string.isRequired,
  colors: PropTypes.object.isRequired,
}
